"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedContent = void 0;
var _axios = require("@ori/axios");
var _logger = require("../logger");
/* eslint-disable @typescript-eslint/naming-convention -- HTTP header names */

const getSharedContent = async () => {
  // TODO: API for this?
  const contentInfoUrl = '/system/ajax/CustomerOrderDetail/GetBasketLink';
  (0, _logger.logDebug)('Loading shared content ...');
  const response = await _axios.axios.get(`${window.location.origin}${contentInfoUrl}`, {
    headers: {
      'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Service-Worker-Allowed': '/',
      Pragma: 'no-cache',
      Expires: '0'
    }
  });
  const {
    data
  } = response;
  const message = data.message.replaceAll('\n\n, ', ', \n\n').replaceAll(/\n{3}/g, '\n\n');
  const result = {
    ...data,
    message
  };
  (0, _logger.logDebug)('getSharedContent() data:', result);
  return result;
};
exports.getSharedContent = getSharedContent;